var e={exports:{}};export{e as __module};
//# sourceMappingURL=advancedFormat.js.map
